import { EffectsCommandMap } from 'dva';
import { ConnectState } from '@/models/connect';
import { FUtil, FServiceAPI } from '@freelog/tools-lib';
import { history } from '@@/core/history';
import type {
  ChangeAction,
  OnMountPageAction,
  OnUnmountPageAction,
  OnMountPageSiderAction,
  OnUnmountPageSiderAction,
  OnChangePageAction,
  OnMountExhibitPageAction,
  OnUnmountExhibitPageAction,
  OnMountThemePageAction,
  OnUnmountThemePageAction,
  OnMountRulePageAction,
  OnUnmountRulePageAction,
  FetchNodeInfoAction,
  FetchExhibitListAction,
  FetchThemeListAction,
  Fetch_Rules_Action,
} from './types';
import { exhibitInitStates, themeInitStates, ruleInitSates } from './initialState';

export const pageEffects = {
  * onMountPage({}: OnMountPageAction, {}: EffectsCommandMap) {

  },
  * onUnmountPage({}: OnUnmountPageAction, {}: EffectsCommandMap) {

  },
  * onMountPageSider({ payload }: OnMountPageSiderAction, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        node_ID: payload.nodeID,
      },
    });

    yield put<FetchNodeInfoAction>({
      type: 'fetchNodeInfo',
    });
  },
  * onUnmountPageSider({}: OnUnmountPageSiderAction, {}: EffectsCommandMap) {

  },
  * onChangePage({ payload }: OnChangePageAction, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        showPage: payload.value,
      },
    });
  },
  * onMountExhibitPage({}: OnMountExhibitPageAction, { select, put }: EffectsCommandMap) {
    yield put<FetchExhibitListAction>({
      type: 'fetchExhibitList',
      payload: {
        isRematch: true,
        isRestart: true,
      },
    });
  },
  * onUnmountExhibitPage({}: OnUnmountExhibitPageAction, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        ...exhibitInitStates,
      },
    });

  },

  * onMountThemePage({}: OnMountThemePageAction, { put }: EffectsCommandMap) {
    yield put<FetchThemeListAction>({
      type: 'fetchThemeList',
      payload: {
        isRematch: true,
      },
    });
  },
  * onUnmountThemePage({}: OnUnmountThemePageAction, { put }: EffectsCommandMap) {
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        ...themeInitStates,
      },
    });
  },
  * onMountRulePage({}: OnMountRulePageAction, { put }: EffectsCommandMap) {
    yield put<Fetch_Rules_Action>({
      type: 'fetch_Rules',
    });
  },
  * onUnmountRulePage({}: OnUnmountRulePageAction, { put }: EffectsCommandMap) {
    window.onbeforeunload = null;
    yield put<ChangeAction>({
      type: 'change',
      payload: {
        ...ruleInitSates,
      },
    });
  },
  * fetchNodeInfo({}: FetchNodeInfoAction, { select, put, call }: EffectsCommandMap) {
    const { informalNodeManagerPage }: ConnectState = yield select(({ informalNodeManagerPage }: ConnectState) => ({
      informalNodeManagerPage,
    }));

    const params: Parameters<typeof FServiceAPI.Node.details>[0] = {
      nodeId: informalNodeManagerPage.node_ID,
    };

    const { data } = yield call(FServiceAPI.Node.details, params);

    if (FUtil.Tool.getUserIDByCookies() !== data.ownerUserId) {
      history.replace(FUtil.LinkTo.exception403({}));
      return;
    }

    if (data.status === -1) {
      history.replace(FUtil.LinkTo.nodeDeleted({ nodeID: informalNodeManagerPage.node_ID }));
      return;
    }

    yield put<ChangeAction>({
      type: 'change',
      payload: {
        node_Name: data.nodeName,
        node_Url: FUtil.Format.completeUrlByDomain(data.nodeDomain || ''),
        node_TestUrl: FUtil.Format.completeUrlByDomain(data.nodeDomain + '.t'),
      },
    });
  },
};
